<template>
  <div class="login-bg" v-if="$isPc || limitDeviceSizeYn">
    <validation-observer ref="loginObserver">
      <div class="bg-img"></div>
      <div class="login-box" v-if="step == 1">
      <img alt="logo" src="@/assets/login/logo.jpg" style="height: 110px" />
      <div class="login-title">業務員入口網</div>

        <validation-provider
            v-slot="{ errors }"
            vid="username"
            name="員工編號(7碼)"
            rules="required"
          >
            <div class="text-xs-left">員工編號(7碼)：</div>
            <v-text-field
              v-model="username"
              placeholder=""
              :error-messages="errors"
              @blur="$f2hHandler('username', 'w')"
              v-mask="'XXXXXXXXXXXX'"
              class="login-field no-focus-border"
              outline
            ></v-text-field>
          </validation-provider>
          <div class="p-rel">
            <validation-provider
              v-slot="{ errors }"
              vid="password"
              name="密碼"
              rules="required"
            >
              <div class="text-xs-left">密碼(8~12碼)：</div>
              <v-text-field
                v-model="password"
                placeholder=""
                maxlength="12"
                type="password"
                :error-messages="errors"
                @blur="$f2hHandler('password', 'k')"
                class="login-field no-focus-border"
                outline
              ></v-text-field>
            </validation-provider>
          </div>
          <div
            class="text-xs-right"
            style="position: absolute; right: 30px; margin-top: -25px"
          >
            <a style="text-decoration: underline" @click="forgetPawd">忘記密碼</a>
          </div>
          <div class="p-rel mt-1 d-flex" v-if="grecapthaHasBroken">
            <validation-provider
              v-slot="{ errors }"
              ref="captcha"
              vid="captcha"
              name="驗證碼"
              rules="required|chaptcha"
              mode="passive"
            >
              <v-text-field
                v-model="captcha"
                @blur="$f2hHandler('captcha', 'k')"
                placeholder=""
                prefix="驗證碼"
                maxlength="6"
                outline
                style="max-width: 170px"
                :error-messages="errors"
                class="login-field no-focus-border"
              ></v-text-field>
            </validation-provider>
            <img
              alt="驗證碼"
              :src="captchaCodeImage"
              style="width: 87px; height: 40px"
            />
            <div class="p-ab" @click="captchaReset">
              重新產生
              <img alt="logo" src="@/assets/login/resetmark.svg" class="ml-2" />
            </div>
          </div>
          <div v-else class="mt-2">
            <div> <!-- 兩層 div 避開 google Recaptcha 遮住問題 -->
              <div
                id="gRequest"
                style="display: flex; justify-content: center"
                data-sitekey="6LfCDpIgAAAAAFSS91vdhkHKwsJ_whTDN0B7szx6" >
              </div>
            </div>
          </div>
          <p class="mt-3 mb-1 text-xs-left">
            1.登入帳號為使用者員工編號7碼(凱銀同仁及外部承攬人請洽保經窗口)。
          </p>
          <p class="mb-1 text-xs-left">
            2.本系統不提供使用行動裝置(手機/平板)進行業務員職前及在職訓練系統。
          </p>
          <btn-lg-primary class="login-btn" @click="loginHandler">登入</btn-lg-primary>
        </div>

        <div class="login-box" v-if="step == 2">
          <img alt="logo" src="@/assets/login/logo.jpg" style="height: 110px" />
          <div class="login-title">業務員入口網</div>
          <v-flex sm12>
            <v-layout row>
              <v-flex>
              <p class="mb-1 ">請輸入一次性驗證碼(OTP)</p>
              <p class="mb-1 ">以登入 行動/遠距投保/業務員訓練系統</p>
              <div id="loginOtpID"  class="p-rel mt-1 d-flex">
                <validation-provider v-slot="{errors}"
                                  vid="loginOtp"
                                  name="一次性驗證碼(OTP)"
                                  rules="required">
                    <v-text-field placeholder="請輸入驗證碼"
                                  maxlength="6"
                                  v-mask="'######'"
                                  v-model="loginOtp"
                                  style="width:100%;margin-bottom: 30px;"
                                  :error-messages="errors"
                                  outline></v-text-field>
                </validation-provider>
                <btn-lg-primary color="primary"
                                dark
                                style="max-width: 40px;min-width: 40px;height: 40px;margin-top:0px!important"
                                @click="loginHandler2">確認</btn-lg-primary>
                </div>
                <div >
                  <v-radio-group row class="align-center justify-center"
                                v-model="loginOtpType">
                    <v-radio v-for="(item,index) in loginOtpTypeList"
                            :key="index"
                            :label="item.codeName"
                            :value="item.codeValue"></v-radio>
                  </v-radio-group>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

        <btn-lg-primary class=""
                        :disabled="loginOtpDisabled"
                        @click="loginOTPreSend">重新發送</btn-lg-primary>
      </div>

      <div class="login-box" v-if="step == 3">
        <img alt="logo" src="@/assets/login/logo.jpg" style="height: 110px" />
        <div class="login-title">業務員入口網</div>
        <v-flex sm12>
          <v-layout row>
            <v-flex>
              <validation-provider v-slot="{errors}"
                                  vid="branCodeRold"
                                  name="系統角色"
                                  rules="required">
                <div id="branCodeID"
                    class="menu-has-id">
                  <v-autocomplete v-model="userRole"
                                  return-object
                                  :items="userRoleList"
                                  :search-input.sync="userRoleSync"
                                  item-text="roleName"
                                  maxlength="20"
                                  hide-no-data
                                  no-data-text=""
                                  style="width:100%;margin-bottom: 30px;"
                                  class="d-in-block"
                                  placeholder="系統角色"
                                  :error-messages="errors"
                                  outline></v-autocomplete>
                </div>
              </validation-provider>

            </v-flex>
          </v-layout>
        </v-flex>
        <btn-lg-primary class="login-btn"
                        @click="loginHandler3">確定</btn-lg-primary>
      </div>
    </validation-observer>

    <v-dialog v-model="resetPawdDialog" persistent max-width="600px">
      <v-card-title style="justify-content: center">
        <span class="headline">重設密碼</span>
      </v-card-title>
      <v-card-text>
        <validation-observer ref="forgetPassObserver">
          <table class="table-bordered">
            <tbody>
              <tr>
                <th style="width: 30%">員工編號(7碼)</th>
                <td v-if="userInput">{{ username }}</td>
                <td v-else>
                  <validation-provider
                    v-slot="{ errors }"
                    vid="resetUserName"
                    name="員工編號(7碼)"
                    rules="required|min:7"
                  >
                    <v-text-field
                      placeholder="請輸入"
                      outline
                      :error-messages="errors"
                      :readonly="reSetPawdPass"
                      v-mask="'XXXXXXXXXXXX'"
                      v-model="resetUserName"
                      @blur="$f2hHandler('resetUserName', 'w')"
                    ></v-text-field>
                  </validation-provider>
                </td>
              </tr>
              <tr>
                <th>身分證字號(後4碼)：</th>
                <td>
                  <validation-provider
                    v-slot="{ errors }"
                    vid="resetIdn"
                    name="身分證字號(後4碼)"
                    rules="required|min:4"
                  >
                    <v-text-field
                      placeholder="請輸入"
                      outline
                      :error-messages="errors"
                      :readonly="reSetPawdPass"
                      v-mask="'####'"
                      maxlength="4"
                      v-model="resetIdn"
                    ></v-text-field>
                  </validation-provider>
                </td>
              </tr>
              <tr>
                <th>請輸入新密碼(8~12碼)：</th>
                <td>
                  <validation-provider
                    v-slot="{ errors }"
                    vid="resetNewPawd"
                    name="新密碼"
                    rules="required|paswbetween:8,12|continuous|includeNumAndWord"
                  >
                    <v-text-field
                      placeholder="請輸入"
                      outline
                      type="password"
                      :error-messages="errors"
                      :readonly="reSetPawdPass"
                      maxlength="20"
                      v-model="resetNewPawd"
                      @blur="$f2hHandler('resetNewPawd', 'k')"
                    ></v-text-field>
                  </validation-provider>
                  <a
                    href="#"
                    onclick="return confirm('1.應至少8位數，最多12位數。\r2.應採英數字混合使用，且宜包含大小寫英文字母或符號。\r3.不得使用客戶之統一編號及身分證字號等顯性資料作為密碼。\r4.不可為連續3個相同英文字(AAA)、連續3個相同數字(222、000)、連續3個連號數字(123、345、890)、連續3個連續英文數字(abc、efg)。\r5.密碼與代號/帳號不應相同。\r6.變更密碼不得與前三次相同。\r7.年度必修法遵課程閱讀通過驗證時除輸入員工編號為帳號，外部課程驗證輸入之密碼不得含「&」，故請勿設定密碼含該值。');"
                    >閱讀密碼規範</a
                  >
                </td>
              </tr>
              <tr>
                <th>請再次輸入新密碼(8~12碼)：</th>
                <td>
                  <validation-provider
                    v-slot="{ errors }"
                    vid="resetAgainPawd"
                    name="新密碼"
                    rules="required|paswbetween:8,12|continuous|includeNumAndWord"
                  >
                    <v-text-field
                      placeholder="請輸入"
                      v-model="resetAgainPawd"
                      outline
                      type="password"
                      :readonly="reSetPawdPass"
                      :error-messages="errors"
                      maxlength="20"
                      @blur="$f2hHandler('resetAgainPawd', 'k')"
                    ></v-text-field>
                  </validation-provider>
                </td>
              </tr>
            </tbody>
          </table>
        </validation-observer>
        <validation-observer ref="otpObserver">
          <table class="table-bordered" v-if="reSetPawdPass">
            <tbody>
              <tr>
                <th style="width: 30%">請輸入OTP驗證碼：</th>
                <td>
                  <validation-provider
                    v-slot="{ errors }"
                    vid="otpCode"
                    name="OTP驗證碼"
                    rules="required|min:6|valideNum"
                  >
                    <v-text-field
                      placeholder="請輸入"
                      outline
                      :error-messages="errors"
                      :disabled="!sendOtpClick"
                      v-mask="'XXXXXX'"
                      v-model="otpCode"
                    ></v-text-field>
                  </validation-provider>
                  <a @click="reSendOtpCode" :disabled="!reSetPawdPass"
                    >重新取得OTP驗證碼</a
                  >
                  <br />系統將發送OTP驗證碼至您的個人信箱(內網保經業管系統-行動辦公室登錄之信箱,凱基銀行同仁及承攬人請洽凱基保經窗口)
                </td>
              </tr>
            </tbody>
          </table>
        </validation-observer>
      </v-card-text>
      <v-card-actions style="justify-content: center">
        <v-btn color="secondary" outline @click="closeForgetPawd(true)">關閉</v-btn>
        <v-btn
          color="secondary"
          @click="forgetPassHandler"
          v-if="!reSetPawdPass"
          >驗證密碼</v-btn
        >
        <v-btn
          color="secondary"
          @click="vertifyOtp"
          v-if="reSetPawdPass"
          :disabled="!sendOtpClick"
          >確定</v-btn
        >
      </v-card-actions>
    </v-dialog>
  </div>
  <div v-else style="display:block;
              margin:50px auto;
              text-align: center;
              font-size: 18px;"> {{$isNotPcMsg}}</div>
</template>
<script>
import { halfFull } from "@/mixin";
import { rsaEncryptor } from "@/mixin/rsaEncryptor";
import axios from "axios";
import isEmpty from "lodash/isEmpty";
import { createNamespacedHelpers } from "vuex";
// import Watermark from '@/utils/watermark'
const { mapActions } = createNamespacedHelpers("user");
const { mapActions: commonMapActions } = createNamespacedHelpers("common");
const isDev = process.env.NODE_ENV === "development";
const devAccount = process.env.VUE_APP_DEV_ACCOUNT;
const devP = "123456";
const passReapcha = process.env.VUE_APP_PASS_REAPCHA === "PASS";
export default {
  name: "the-login",

  mixins: [halfFull, rsaEncryptor],

  props: {
    showVer: String,
    resetUserCode: String,
  },
  data() {
    return {
      step: 1,
      inter: null,
      keepVer: "",
      userInput: true, // 重設密碼 帳號輸入或代入值
      branCodeRole: null,
      username: isDev ? devAccount : null,
      password: null,
      captcha: isDev ? "999999" : null,
      captchaCodeImage: null,
      googleRecaptchaToken: null,
      grecapthaHasBroken: false,
      otpRecCode: null, // OTP流水號
      resetPawdDialog: false, // 忘記密碼區域顯示判斷
      resetUserName: null, // 重設密碼-員工編號(7碼)
      resetIdn: null, // 重設密碼-身分證字號(後4碼)
      resetNewPawd: null, // 重設密碼-新密碼
      resetAgainPawd: null, // 重設密碼-再次輸入新密碼
      otpCode: null, // 重設密碼-OTP驗證碼
      reSetPawdPass: false, // 重新輸入密碼通過驗檢核
      sendOtpClick: false, // 發送OTP開啟確定跟輸入框
      noChangePwd: false, // 跳出提示變更密碼使窗還按取消，要直接登入
      userRoleList: [],
      userRole: null,
      userRoleSync: null,
      loginOtp: null, //畫面上的otp驗證碼
      loginOtpType: null, // 重新發送OTP類型
      defaultOtpResendSeconds: null, // 預設驗證碼重發秒數
      otpResendSeconds: null, // 驗證碼重發秒數
      otpResendCountfunc:null, //定時器ID
      loginOtpDisabled:false, // 驗證碼重發按鈕反灰
      sendOtpMobileYn: false, // 重新發送OTP 選擇電話時檢查使用者有沒有資料
      loginOtpTypeList: [  // 重新發送OTP類型選項清單
        { codeName: 'EMAIL' ,codeValue: 'E' },
        { codeName: '行動電話',codeValue: 'M' }
      ],
      limitDeviceSizeYn: null, // 限制使用者裝置尺寸
    };
  },
  mounted() {
    // 先不開啟浮水印
    // this.$api.get('/public/getWatermarkTxt').then(r => {
    //   Watermark.set(r.data)
    // }).catch(() => {})
    // this.$api.get('/public/getVer').then(r => {
    //   console.log('api ver:' + r.data)
    // })
    axios.get("ver.txt?t=" + new Date().getTime()).then((r) => {
      this.keepVer = r.data;
      // console.log("ui ver:" , filterVaildLog(r.data));
      this.inter = window.setInterval(() => {
        axios.get("ver.txt?t=" + new Date().getTime()).then((r2) => {
          if (r2.data !== this.keepVer) {
            // 版號有異動
            // alert('版號有異動')
            window.location.reload();
          }
        });
      }, 30000);
    });
    // 限制使用者裝置尺寸  Y:不能用手機 N:可以用手機
    this.$store.dispatch('common/fetchCellphoneSwitch').then(r => {
      this.limitDeviceSizeYn = r.data === 'N'
    })
    //fix: Issue #79591，開發 停站的前台呈現與判斷
    const self = this
    this.fetchSystemActiveParam().then(r => {
      const {parameterValue , variableDesc} = r.data
      if(parameterValue === 'N'){
        self.$alert(variableDesc , null ,{hideCloseBtn: true})
        //self.$alert(variableDesc)
        //self.$store.commit('START')
      }
    })
  },
  destroyed() {
    window.clearInterval(this.inter);
  },
  created() {
    if (isDev) {
      this.password = devP;
    }
    if (!isEmpty(this.resetUserCode)) {
      // 透過URL 帶入員工編號(7碼) 並重設密碼
      this.resetPawdDialog = true; // URL 導入顯示忘記密碼區域
      this.userInput = true;
      let base64DecodedString = window.atob(this.resetUserCode);
      this.username = base64DecodedString; // 如果是帶入的資料
    }
    const $htmlScroll = document.documentElement;
    $htmlScroll.className = "";
    this.generateCaptchaCodeImage();
    let servMsg = localStorage.getItem("servMsg");
    if (servMsg != null) {
      localStorage.removeItem("servMsg"); // 登出移除公告訊息
    }
    if (passReapcha) {
      this.grecapthaHasBroken = true;
    } else {
      this.googleValidator();
    }
  },
  watch: {
    userRoleSync (v) {
      !v && (this.userRole = null)
    },
    branCodeSync(v) {
      !v && (this.branCodeRole = null);
    },
    otpResendSeconds: function (val) {
      if (val <= 0) { // 判斷倒數秒數
        this.loginOtpDisabled = false // 打開傳送驗證碼按鈕
        this.otpResendSeconds = 0 // 歸零倒數數秒路
        window.clearInterval(this.otpResendCountfunc) // 停止setInterval 執行
      }
    }
  },
  computed: {},
  methods: {
    ...mapActions([
      "login",
      "fetchUserInfo",
      "fetchCaptcha",
      "featchBranCodeRole",
      "changeBranCodeRole",
      "googleApiValidator",
      "vertifyRePawd",
      "sendOtpCaptcha",
      "verifyOtpCaptcha",
      "pwExpireSendMail",
      "loginOtpSendHendler",
      "loginOtpValidate",
    ]),
    ...commonMapActions([ "getGoogleSiteKey","fetchSingleParam" , "fetchSystemActiveParam"]),
    googleValidator() {
      this.googleApiValidator().then((r) => {
        if (r.data === false) {
          this.grecapthaHasBroken = true;
        } else {
          this.onloadCallback();
        }
      });
    },
    onloadCallback: function () {
      if (window.grecaptcha === undefined) {
        // recaptcha權限被擋
        this.grecapthaHasBroken = true;
      } else {
        this.getGoogleSiteKey().then((r) => {
          if (r.data.param_value) {
            if (!window.grecaptcha) {
              this.googleValidator();
              return;
            }
            if (typeof window.grecaptcha.render !== "function") {
              this.googleValidator();
              return;
            }
            window.grecaptcha.render(
              document.getElementById("gRequest"),
              {
                sitekey: r.data.param_value,
                callback: this.submit,
                "error-callback": this.reCheckError,
                "expired-callback": this.expiredError
              }
            );
          } else {
            this.$alert("google api參數錯誤，請重新確認");
          }
        });
      }
    },
    submit: function (token) {
      this.googleRecaptchaToken = token;
    },
    reCheckError: function () {
      this.$alert("google驗證碼發生錯誤，請改成直接輸入驗證碼");
      this.grecapthaHasBroken = true;
    },
    expiredError: function () {
      this.$alert("google驗證碼過期，請重新驗證");
      this.googleValidator();
    },
    loginHandler() {
      if (
        !this.googleRecaptchaToken &&
        this.grecapthaHasBroken === false &&
        !this.noChangePwd &&  // 您的密碼已達X天未變更，是否重新設定密碼?點取消要跳過勾選機器人
        !passReapcha
      ) {
        this.$alert("請勾選「我不是機器人」!");
        return;
      }
      this.$doValidate("loginObserver").then((isValid) => {
        let resetVertify = false
        if (isValid) {
          const recaptchaToken = this.googleRecaptchaToken;
          let vm = this;
          const username = this.encrypt(this.username); // 帳密RSA加密post到後端解密
          const password = this.encrypt(this.password);
          const captcha = this.captcha;
          const noChangePwd = this.noChangePwd; // 跳出提示變更密碼使窗還按取消，要直接登入
          this.login({
            username,
            password,
            captcha,
            recaptchaToken,
            noChangePwd,
          }).then((r) => {
            if (r.status === 200) {
              let loginOtpEnableYn = r.data.loginOtpEnableYn[0] //	判斷是否有啟用OTP驗証功能
              vm.sendOtpMobileYn = r.data.mobileYn[0] //	判斷是否有啟用OTP驗証功能
              const [msg] = r.data.msg || [];
              if (msg) {
                  vm.$alert(msg, null, { btnConfirmText: '點選我, 重新登入' }).then(() => {
                    vm.loginOtpValidateThenChangeRoleCodeAndBranCode(loginOtpEnableYn) // 判斷要不要發送OTP驗証碼然後再判斷要不要選擇角色
                  });
              } else {
                vm.loginOtpValidateThenChangeRoleCodeAndBranCode(loginOtpEnableYn); // 判斷要不要發送OTP驗証碼然後再判斷要不要選擇角色
              }
            } else if (r.data.errorCode === "516") {
              // 發生錯誤顯示訊息
              this.$alert(r.data.message.length > 1? r.data.message : r.data.message.toString());
            } else if (r.data.errorCode === "517") {
              // 第一次進入，先跳訊息再進入忘記密碼區域
              this.$alert(r.data.message, (yn) => {
                this.resetPawdDialog = true;
                this.userInput = true;
              });
              this.$reset("loginObserver");
            } else if (r.data.errorCode === "518") {
              // 密碼輸入錯誤超過次數、密碼超過90天未變更
              // 先跳訊息  點確定再進入忘記密碼區域 點取消留在原頁面
              this.$confirm(r.data.message).then((yn) => {
                if (yn) {
                  this.resetPawdDialog = true;
                  this.userInput = true;
                  this.$reset("loginObserver");
                  this.resetLoginTextfield();
                }
              });
            } else if (r.data.errorCode === "519") {
              resetVertify = true // 跳出提示變更密碼使窗還按取消 不要更新驗證碼或清除recapcha驗證
              // 密碼過期提示要更改密碼，點確定進入，點取消發mail( XX天未變更，直接登入)
              this.$confirm(r.data.message).then((yn) => {
                if (yn) {
                  this.resetPawdDialog = true;
                  this.userInput = true;
                  this.$reset("loginObserver");
                  this.resetLoginTextfield();
                } else {
                  const params = {
                    userCode: this.username,
                  };
                  this.pwExpireSendMail(params);
                  this.noChangePwd = true; // 跳出提示變更密碼使窗還按取消，要直接登入(後端判斷)
                  this.loginHandler519()
                }
              });
            } else if (r.status === 401) {
              const { data } = r;
              this.$alert(data.message);
            }
            if (!resetVertify) {
              this.googleRecaptchaToken = "";
              this.captchaReset();
            }
          });
        }

      });
    },
    loginOTPreSend () { // 登入OTP 重新發送
      if (this.loginOtpType  === null){
        this.$alert('請選擇EMAIL或行動電話發送驗證碼 !')
        return false
      } else if (this.loginOtpType === 'E') {  // loginOtpType === 電子郵件
        this.loginOtpSendHendler({ sendTypeCode: 'E' }).then( r => {
          if ( r.data.errorMsg === null ) {
            this.otpRecCode = r.data.otpRecCode; // OTP 流水號
            this.$alert(r.data.alertMsg) //'驗證碼已成功發送至您的[個人信箱]或[行動電話] !')
          }else{
              this.$alert(r.data.errorMsg) // 顯示發送失敗的錯誤訊息
            }
        })
      } else {  // loginOtpType === M 行動電話
        if (this.sendOtpMobileYn) { //
          this.loginOtpSendHendler({ sendTypeCode: 'M' }).then( r => {
            if ( r.data.errorMsg === null ) {
              this.otpRecCode = r.data.otpRecCode; // OTP 流水號
              this.$alert(r.data.alertMsg) //'驗證碼已成功發送至您的[個人信箱]或[行動電話] !')
            }else{
              this.$alert(r.data.errorMsg)  // 顯示發送失敗的錯誤訊息
            }
          })
        } else {
          this.$alert('您在系統內無留存手機號碼，故無法發送，請改用Email收OTP，或至保經業管系統行動辦公室＼個人資料維護增加手機號碼')
          return false
        }
      }
      this.otpResendSeconds = this.defaultOtpResendSeconds // 設定動態密碼重發秒數
      this.loginOtpDisabled = true // 反灰傳送驗證碼按鈕
      this.otpResendCountfunc = window.setInterval(this.otpCountdownfunc, 1000) //指定定時器ID 每隔X微秒呼叫function
    },
    otpCountdownfunc () { // 登入OTP 倒數秒數
      this.otpResendSeconds--
    },
    loginHandler2 () { // 登入OTP驗證
      this.$doValidate("loginObserver").then((isValid) => {
        if (isValid) {
          this.loginOtpValidate( {otpCode: this.loginOtp,otpRecCode: this.otpRecCode } ).then((r) => {
            if (r.data.length > 0) {
              this.$alert(r.data.length > 1 ? r.data : r.data.toString())
            } else {
              this.changeRoleCodeAndBranCode(); // 更新roleCode跟branCode與選擇角色
            }
          });
        }
      })
    },
    loginHandler3 () { //選擇角色
      this.$doValidate('loginObserver').then(isValid => {
        if (isValid) {
          this.changeBranCodeRole({
            branCode: this.userRole.branCode,
            roleCode: this.userRole.roleCode,
          }).then((r) => {
            if(isEmpty(r.data)) {
              this.fetchUserInfo().then((response) => {
                this.$router.replace("home");
              });
            } else {
              this.$alert(r.data, yn => {  // 未具備壽險登錄證字號或已註銷登錄，無法使用行動投保系統
                this.$store.dispatch("user/logout");
                window.location.reload()
              })
            }
          })
        }
      })
    },
    // 密碼過期提示要更改密碼，點取消要進入登入，因已通檢查碼驗證故直接進入登入流程
    loginHandler519 () {
      let vm = this;
      const recaptchaToken = this.googleRecaptchaToken;
      const username = this.encrypt(this.username); // 帳密RSA加密post到後端解密
      const password = this.encrypt(this.password);
      const captcha = this.captcha;
      const noChangePwd = this.noChangePwd; // 跳出提示變更密碼使窗還按取消，要直接登入
      this.login({
        username,
        password,
        captcha,
        recaptchaToken,
        noChangePwd,
      }).then((r) => {
        if (r.status === 200) {
          let loginOtpEnableYn = r.data.loginOtpEnableYn[0] //	判斷是否有啟用OTP驗証功能
          const [msg] = r.data.msg || [];
          if (msg) {
              vm.$alert(msg, null, { btnConfirmText: '點選我, 重新登入' }).then(() => {
                vm.loginOtpValidateThenChangeRoleCodeAndBranCode(loginOtpEnableYn) // 判斷要不要發送OTP驗証碼然後再判斷要不要選擇角色
              });
          } else {
            vm.loginOtpValidateThenChangeRoleCodeAndBranCode(loginOtpEnableYn); // 判斷要不要發送OTP驗証碼然後再判斷要不要選擇角色
          }
        }
      })
    },
    loginOtpValidateThenChangeRoleCodeAndBranCode (loginOtpEnableYn) { // 發送OTP驗証碼然後再判斷要不要選擇角色
      let vm = this;
      if ('Y' === loginOtpEnableYn) { // 有啟用OTP驗證
        vm.step = 2
        this.loginOtpSendHendler({ sendTypeCode: 'E' }).then( r => { //後端OTP卡控 OtpValidate會通過
          if ( r.data.errorMsg === null ) {
            this.otpRecCode = r.data.otpRecCode; // OTP 流水號
            vm.$alert(r.data.alertMsg) //'驗證碼已成功發送至您的[個人信箱]或[行動電話] !')
          }
        })
        this.fetchSingleParam({ type :'ADM', code: "OTP_RESEND_SECONDS" }).then(r =>{
          this.defaultOtpResendSeconds = r.data.parameterValue // 設定預設的驗證碼重發秒數
        })
      }else{
        //後端OTP卡控 OtpValidate 直接設定通過
        vm.changeRoleCodeAndBranCode();  // 更新roleCode跟branCode與選擇角色
      }
    },
    changeRoleCodeAndBranCode() { // 更新roleCode跟branCode與選擇角色
      let vm = this;
      vm.featchBranCodeRole().then((r2) => {
        if (r2.data && r2.data.length === 1) {
          // 只有一個角色，直接跳轉
          vm.changeBranCodeRole({
            branCode: r2.data[0].branCode,
            roleCode: r2.data[0].roleCode,
          }).then((r) => {
            if(isEmpty(r.data)) {
              this.fetchUserInfo().then((response) => {
                this.$router.replace("home");
              });
            } else {
              this.$alert(r.data, yn => {  // 未具備登錄證字號或已註銷登錄，無法使用行動投保系統
                this.$store.dispatch("user/logout");
                window.location.reload()
              })
            }
          });
        } else{ // 進入角色選擇頁面
          vm.step = 3
          vm.userRoleList =  r2.data
        }
      });
    },

    forgetPawd() { // 忘記密碼
      this.$store.dispatch("common/postUserAccessLog", {
        userCode: this.username,
        progClassName: "forgetPwd",
        methodName: "忘記密碼",
      });
      // 點擊忘記密碼按鈕
      this.resetPawdDialog = true;
      this.userInput = false; // 員工編號(7碼)可編輯 預設空白
    },

    closeForgetPawd(isLog) {
      if (isLog) {
        this.$store.dispatch("common/postUserAccessLog", { userCode: this.username, progClassName: "closeForgetPwd", methodName: "關閉"})
      }
      // 清空忘記密碼裡面的所有欄位
      this.resetUserName = null; // 重設密碼-員工編號(7碼)
      this.resetIdn = null; // 重設密碼-身分證字號(後4碼)
      this.resetNewPawd = null; // 重設密碼-新密碼
      this.resetAgainPawd = null; // 重設密碼-再次輸入新密碼
      this.otpCode = null; // 重設密碼-OTP驗證碼
      this.otpRecCode = null; // 重設密碼-OTP驗證碼
      this.resetPawdDialog = false;
      this.reSetPawdPass = false;
      this.sendOtpClick = false;
      this.$reset("forgetPassObserver");
    },
    forgetPassHandler() {
      this.$store.dispatch("common/postUserAccessLog", {
        userCode: this.username,
        progClassName: "checkPwd",
        methodName: "驗證密碼",
      });
      //重設密碼 重新輸入密碼 驗證
      this.$doValidate("forgetPassObserver").then((isValid) => {
        if (isValid) {
          const { userInput, resetIdn, resetNewPawd, resetAgainPawd } = this;
          let userCode = userInput ? this.username : this.resetUserName; // 如果是帶入的資料
          //(3)	先檢核密碼規範
          if (resetNewPawd === userCode) {
            this.$alert("密碼和帳號不可相同！");
            return;
          }
          if (resetNewPawd !== resetAgainPawd) {
            this.$alert("新密碼 和 再次輸入新密碼 輸入不一致，請重新輸入！");
            return;
          }
          let encryptNewPawd = this.encrypt(resetNewPawd); // 帳密RSA加密post到後端解密
          const params = {
            resetUserName: userCode,
            resetIdn,
            resetNewPawd: encryptNewPawd,
          };
          this.vertifyRePawd(params).then((r) => {
            if (r.data.length > 0) {
              this.$alert(r.data.length > 1 ? r.data : r.data.toString())
            } else {
              this.$alert("驗證成功", (yn) => {
                this.reSendOtpCode();
                this.reSetPawdPass = true;
              });
            }
          });
        }
      });
    },
    reSendOtpCode() { //  重設密碼發送otp驗證碼
      let userCode = this.userInput ? this.username : this.resetUserName; // 如果是帶入的資料
      this.sendOtpCaptcha({ userCode }).then((r) => {
        if (r.data.otpRecCode != null) {
          this.sendOtpClick = true;
          this.otpRecCode = r.data.otpRecCode; // OTP 流水號
          this.$alert("OTP碼已成功發送至您的個人信箱 !");
        } else {
          this.$alert(r.data.errorMsg);
        }
      });
    },
    vertifyOtp() { // 重設密碼驗鎮OTP
      this.$doValidate("otpObserver").then((isValid) => {
        if (isValid) {
          const { userInput, resetNewPawd, otpCode, otpRecCode } = this;
          // 如果是帶入的資料
          let userCode = userInput ? this.username : this.resetUserName;
          let encryptNewPawd = this.encrypt(resetNewPawd); // 帳密RSA加密post到後端解密
          const params = {
            resetUserName: userCode,
            resetNewPawd: encryptNewPawd,
            otpCode,
            otpRecCode,
          };
          this.$store.dispatch("common/postUserAccessLog", {
            userCode: this.username,
            progClassName: "checkOTP",
            methodName: "確定",
            actionMsg: "輸入OTP驗證碼=" + otpCode,
          });
          this.verifyOtpCaptcha(params).then((r) => {
            // 忘記密碼-驗證OTP
            if (!isEmpty(r.data)) {
              this.$alert(r.data); // 密碼輸入錯誤超過次數，先跳訊息在重設密碼
            } else {
              this.$alert("密碼設定完成，請重新登入系統！", (yn) => {
                this.resetPawdDialog = false;
                this.closeForgetPawd(false); // 清空忘記密碼裡面的所有欄位
              });
            }
          });
        }
      });
    },
    captchaReset() {
      this.generateCaptchaCodeImage();
      try {
        window.grecaptcha.reset();
      } catch (e) {}

    },
    resetLoginTextfield() {
      this.password = null;
      this.captcha = null;
      this.captchaReset();
      this.googleValidator();
    },
    generateCaptchaCodeImage() {
      this.fetchCaptcha().then((response) => {
        //fix: Issue #102049, BUG 修正，避免抓不到 "Content-Type" 資訊
        const contentType= response.headers["Content-Type"] || 'image/jpeg'
        const prefix = `data:${contentType};base64,`;
        this.captchaCodeImage =
          prefix + Buffer.from(response.data, "binary").toString("base64");
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.login-bg {
  width: 100%;
  height: 100%;
}

.login-box {
  width: 400px;
  border-radius: 15px;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.21);
  background-color: #ffffff;
  position: absolute;
  right: 0%;
  top: 50%;
  transform: translate(-10%, -50%);
  padding: 0px 30px 10px;
}

.login-title {
  font-size: 26px;
  font-weight: bold;
  letter-spacing: 2px;
  padding-top: 10px;
  border-top:1px solid #eee;
  margin-bottom: 15px;
  color: #757171;

}

.bg-img {
  background-image: url('../../assets/login/login_bg.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 100%;
  width: 100%;
}

.login-btn {
  padding: 10px 70px;
  border-radius: 50px;
  background: linear-gradient(to bottom, #0940c5, #11336a 100%);
  border: 2px solid #11336a;
  margin-top: 15px;
  border-color: #11336a!important;
}

.p-rel {
  position: relative;
}

.p-ab {
  position: absolute;
  right: 0;
  bottom: 5px;
  cursor: pointer;
}
</style>
<style>
.login-field .v-text-field__prefix {
  max-height: 32px;
  width: 80px;
  font-size: 14px;
  font-weight: bolder;
  color: #9b9b9b;
  margin-top: 0 !important;
  text-align: left;
}
.login-field.v-input--is-focused .v-text-field__prefix {
  margin-top: 0px !important;
}
.login-field.v-text-field--outline > .v-input__control > .v-input__slot {
  border-radius: 50px !important;
  background-color: #f9f9f9 !important;
  border: 0px !important;
  min-height: 30px !important;
}
.login-box .v-text-field--outline .v-input__control .v-input__slot:hover {
  border: 0px !important;
}
.login-field .v-text-field__prefix {
  min-width: 70px;
}
@media screen and (max-width:700px){
  .login-box{
    transform: translate(-0%,-50%)!important;
  }
}
</style>
